export default __webpack_public_path__ + "static/background-dots-7d7e48605ae38e3f993afbaaa7e519d9.svg";